import React, { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import Particles from 'react-tsparticles';

const GeometricBackground = () => {
  const particlesInit = useCallback(async engine => {
    await loadSlim(engine);
  }, []);

  const options = {
    fpsLimit: 120,
    fullScreen: false,
    particles: {
      number: {
        value: 40,
        density: {
          enable: true,
          value_area: 1000
        }
      },
      color: {
        value: ["#cFEA15", "#D9F273"]
      },
      shape: {
        type: ["circle", "triangle"],
      },
      opacity: {
        value: 2,
        random: false,
      },
      size: {
        value: 15,
        random: true,
        anim: {
          enable: true,
          speed: 2,
          size_min: 8,
          sync: false
        }
      },
      line_linked: {
        enable: true,
        distance: 200,
        color: "#BFEA15",
        opacity: 0.8,
        width: 2,
        triangles: {
          enable: true,
          opacity: 0.2
        }
      },
      move: {
        enable: true,
        speed: 1.5,
        direction: "none",
        random: false,
        straight: false,
        out_mode: "bounce",
        bounce: true,
        attract: {
          enable: true,
          rotateX: 600,
          rotateY: 1200
        }
      }
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: true,
          mode: "grab"
        },
        onclick: {
          enable: true,
          mode: "push"
        },
        resize: true
      },
      modes: {
        grab: {
          distance: 250,
          line_linked: {
            opacity: 0.8
          }
        },
        push: {
          particles_nb: 4
        }
      }
    },
    retina_detect: true,
    background: {
      color: "transparent"
    }
  };

  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white to-gray-50 opacity-90" />
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={options}
        className="w-full h-full"
      />
    </div>
  );
};

export default GeometricBackground;
